import React, { useEffect, useState, useContext } from "react";
import Pagination from "react-js-pagination";
import saasService from "../../../services/api/saas-service";
import { useHistory } from "react-router-dom";
import UserContext from "../../../UserContext"
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    Alert,
    Spinner,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Table,
    Container,
    Row,
    Col,
} from "reactstrap";

const CreatePlanGroup = () => {
    const [formdetails, setFormDetails] = useState({ name: "" });
    const [planGroups, setPlanGroups] = useState([]);
    const [namestate, setNameState] = useState("");
    const [nameerror, setNameError] = useState("");
    const [showLoader, setShowLoader] = useState(false);
    const [showSaveButton, setShowSaveButton] = useState(true);
    const [alert, setAlert] = useState({ show: false, message: "", type: "" });
    const history = new useHistory();
    const context = useContext(UserContext);
    useEffect(() => {
        (async () => {
            let groupsData = await saasService.getPlanGroups();
            if (groupsData.status && groupsData.data) {
                setPlanGroups(groupsData.data);
            }
        })();
    }, []);

    const validateName = () => {
        if (formdetails.name === "") {
            setNameState("has-danger");
            setNameError("This field is required");
            return false;
        }

        if (planGroups && planGroups.length > 0) {
            let duplicateName = false;
            planGroups.forEach(function (details) {
                if (formdetails.name === details.name) {
                    duplicateName = true;
                }
            });
            if (duplicateName) {
                setNameState("has-danger");
                setNameError(
                    "You have already created the plan group with this name."
                );
                return false;
            }
        }
        setNameState("has-success");
        return true;
    };

    const validateForm = async () => {
        let nameValidation = validateName();
        if (nameValidation) {
            setShowLoader(true);

            setShowSaveButton(false);

            let newPlanGroup = await saasService.createPlanGroup(formdetails);

            console.log(newPlanGroup);
            if(!newPlanGroup.status && newPlanGroup.error.errorCode === 403) {
                context.setIsAuthorized(context);
            }
            else if (newPlanGroup.status) {
                setTimeout(() => {
                    setShowLoader(false);
                    setAlert({
                        show: true,
                        type: "success",
                        message: "Feature Group was created Successfully",
                    });
                }, 1000);

                setTimeout(() => {
                    setAlert({ show: false, type: "", message: "" });
                }, 3000);

                setTimeout(() => {
                    history.push("/saas/plan-groups");
                }, 2000);
            } else {
                setTimeout(() => {
                    setShowLoader(false);
                    setShowSaveButton(true);
                    setAlert({
                        show: true,
                        type: "danger",
                        message:
                            "Feature Group could not be created, Please try again.",
                    });
                }, 1000);

                setTimeout(() => {
                    setAlert({ show: false, type: "", message: "" });
                }, 3000);
            }
        }
    };

    const handleSubmit = async (event) => {
        validateForm();
        event.preventDefault();
    };

    const handleChange = (event) => {
        setFormDetails({
            ...formdetails,
            [event.target.id]: event.target.value.trim(),
        });

        console.log(formdetails);
    };

    return (
        <div className="content">
            <Container>
                <Row>
                    <Col className="ml-auto mr-auto" md="12">
                        <Card className="card-signup text-center">
                            <CardHeader>
                                <CardTitle tag="h4">
                                    Create Plan Group
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Form
                                    className="form-horizontol"
                                    onSubmit={handleSubmit}
                                >
                                    <Row>
                                        <Label sm="3">Plan Group Name <span class="text-danger"> * </span></Label>
                                        <Col sm="7">
                                            <FormGroup className={namestate}>
                                                <Input
                                                    name="name"
                                                    id="name"
                                                    type="text"
                                                    onChange={handleChange}
                                                />
                                                {namestate === "has-danger" ? (
                                                    <label className="error">
                                                        {nameerror}
                                                    </label>
                                                ) : null}
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    {showSaveButton ? (
                                        <div>
                                            <Button
                                                className="btn-round"
                                                color="info"
                                                type="button"
                                                onClick={validateForm}
                                            >
                                                Create
                                            </Button>
                                            <Button
                                                className="btn-round"
                                                color="danger"
                                                type="button"
                                                onClick={(event) => {
                                                    history.push(
                                                        `/saas/plan-groups`
                                                    );
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    {alert.show ? (
                                        <Alert color={alert.type}>
                                            {alert.message}
                                        </Alert>
                                    ) : (
                                        ""
                                    )}

                                    {showLoader ? (
                                        <Spinner
                                            animation="border"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </Spinner>
                                    ) : (
                                        ""
                                    )}
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default CreatePlanGroup;
